import * as React from 'react'

import { F0Icon } from '@factorialco/f0-react'
import { Tooltip } from '@factorialco/f0-react/dist/experimental'
import { InfoCircleLine } from '@factorialco/f0-react/icons/app'

interface TwoColumnsItemType {
  title: string
  info: string | React.ReactNode
}

interface CustomTwoColumnsListProps {
  title?: string
  titleValue?: string
  titleTooltip?: {
    label?: string
    description: string
  }
  list: TwoColumnsItemType[]
  'data-testid'?: string
}

const CustomTwoColumnsList = ({
  title,
  titleValue,
  titleTooltip,
  list,
  'data-testid': testId,
}: CustomTwoColumnsListProps) => {
  return (
    <div className="pt-2 first:pt-0" data-testid={testId}>
      {/* Title Header */}
      {title && (
        <div className="flex justify-between font-semibold items-center mb-2 px-3">
          <div className="flex items-center gap-2">
            <span className="text-base">{title}</span>
            {titleTooltip && (
              <Tooltip label={titleTooltip.label} description={titleTooltip.description}>
                <F0Icon icon={InfoCircleLine} size="md" color="secondary" />
              </Tooltip>
            )}
          </div>
          {titleValue && <span className="text-base text-right">{titleValue}</span>}
        </div>
      )}

      {/* List Items */}
      {list.length > 0 && (
        <div className="flex flex-col border border-solid border-f1-border-secondary rounded-xl">
          {list.map((item, index) => (
            <React.Fragment key={`${item.title}-${index}`}>
              <div className="flex justify-between items-center px-3 py-2.5">
                <span className="text-base font-normal text-f1-foreground-secondary">
                  {item.title}
                </span>
                {typeof item.info === 'string' ? (
                  <span className="text-base text-right font-semibold text-gray-800">
                    {item.info}
                  </span>
                ) : (
                  item.info
                )}
              </div>
              {index !== list.length - 1 && (
                <div className="h-[1px] w-full bg-f1-border-secondary" />
              )}
            </React.Fragment>
          ))}
        </div>
      )}
    </div>
  )
}

export default CustomTwoColumnsList
